import { render, staticRenderFns } from "./ReceivedMailDetail.vue?vue&type=template&id=1fdf7026"
import script from "./ReceivedMailDetail.vue?vue&type=script&lang=js"
export * from "./ReceivedMailDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fdf7026')) {
      api.createRecord('1fdf7026', component.options)
    } else {
      api.reload('1fdf7026', component.options)
    }
    module.hot.accept("./ReceivedMailDetail.vue?vue&type=template&id=1fdf7026", function () {
      api.rerender('1fdf7026', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/mailbox/ReceivedMailDetail.vue"
export default component.exports